import i18n from '@/i18n';
import { packages } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const Packages = () => import('./views/Index.vue');
const PackageView = () => import('./views/PackageView.vue');

export default [
  {
    path: 'packages',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.Packages`,
        component: Packages,
        meta: {
          title: i18n.global.t('packages.packages'),
          permission: { module: packages.module, key: packages.showAll },
        },
      },
      {
        path: 'view/:id?',
        name: `${PREFIX.INSPECTOR}.Packages.View`,
        component: PackageView,
        meta: {
          title: i18n.global.t('packages.view'),
          pageType: 'view',
          permission: { module: packages.module, key: packages.showOne },
        },
        props: true,
      },
      {
        path: 'create',
        name: `${PREFIX.INSPECTOR}.Packages.Create`,
        component: PackageView,
        meta: {
          title: i18n.global.t('packages.create'),
          pageType: 'create',
          permission: { module: packages.module, key: packages.create },
        },
      },
      {
        path: 'update/:id?',
        name: `${PREFIX.INSPECTOR}.Packages.Update`,
        meta: {
          title: i18n.global.t('packages.update'),
          pageType: 'update',
          permission: { module: packages.module, key: packages.update },
        },
        component: PackageView,
        props: true,
      },
    ],
  },
];
